/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Delete_Event_TextInputs */

const en_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the selected event?`)
};

const fr_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer l'evenement selectionne ?`)
};

const de_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie das ausgewählte Ereignis wirklich löschen?`)
};

const it_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare l'evento selezionato?`)
};

const ru_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить выбранное событие?`)
};

const es_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar el evento seleccionado?`)
};

const zh_cn2_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要删除所选事件吗？`)
};

const ja_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを削除してもよろしいですか?`)
};

const hi_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई चयनित इवेंट को हटाना चाहते हैं?`)
};

const pt_pt2_shortcut_keys_delete_event_text = /** @type {(inputs: Shortcut_Keys_Delete_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o evento selecionado?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete the selected event?" |
*
* @param {Shortcut_Keys_Delete_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_delete_event_text = /** @type {((inputs?: Shortcut_Keys_Delete_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Delete_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_delete_event_text(inputs)
	if (locale === "de") return de_shortcut_keys_delete_event_text(inputs)
	if (locale === "it") return it_shortcut_keys_delete_event_text(inputs)
	if (locale === "ru") return ru_shortcut_keys_delete_event_text(inputs)
	if (locale === "es") return es_shortcut_keys_delete_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_delete_event_text(inputs)
	if (locale === "ja") return ja_shortcut_keys_delete_event_text(inputs)
	if (locale === "hi") return hi_shortcut_keys_delete_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_delete_event_text(inputs)
	return en_shortcut_keys_delete_event_text(inputs)
});